import { apiClient } from '../../axios';
import {
  BaseDefiYieldOverviewResponse,
  GetDefiYieldDetailsResponse,
  GetDefiYieldMintOverviewResponse,
  GetDefiYieldPendingResponse,
  GetDefiYieldRedeemOverviewResponse,
  GetDefiYieldsOverviewResponse,
  PostDefiYieldMintConfirmRequest,
  PostDefiYieldMintConfirmResponse,
  PostDefiYieldMintPreviewRequest,
  PostDefiYieldMintPreviewResponse,
  PostDefiYieldRedeemConfirmRequest,
  PostDefiYieldRedeemConfirmResponse,
  PostDefiYieldRedeemPreviewRequest,
  PostDefiYieldRedeemPreviewResponse,
} from './types';

function createProductApis(slug: string) {
  const base = `/v1/earn/defi-yields/${slug}`;
  return {
    getOverview: () => apiClient.get<BaseDefiYieldOverviewResponse>(`${base}/overview`),
    getMintOverview: () => apiClient.get<GetDefiYieldMintOverviewResponse>(`${base}/mint/overview`),
    postMintPreview: (params: PostDefiYieldMintPreviewRequest) =>
      apiClient.post<PostDefiYieldMintPreviewResponse>(`${base}/mint/preview`, params),
    postMintConfirm: (params: PostDefiYieldMintConfirmRequest) =>
      apiClient.post<PostDefiYieldMintConfirmResponse>(`${base}/mint/confirm`, params),
    getRedeemOverview: () => apiClient.get<GetDefiYieldRedeemOverviewResponse>(`${base}/redeem/overview`),
    postRedeemPreview: (params: PostDefiYieldRedeemPreviewRequest) =>
      apiClient.post<PostDefiYieldRedeemPreviewResponse>(`${base}/redeem/preview`, params),
    postRedeemConfirm: (params: PostDefiYieldRedeemConfirmRequest) =>
      apiClient.post<PostDefiYieldRedeemConfirmResponse>(`${base}/redeem/confirm`, params),
    getDetails: () => apiClient.get<GetDefiYieldDetailsResponse>(`${base}/details`),
    getPending: () => apiClient.get<GetDefiYieldPendingResponse>(`${base}/pending`),
  };
}

export type ProductApis = ReturnType<typeof createProductApis>;

export const narsilApis = createProductApis('narsil');

export const getDefiYieldsOverviewApi = () =>
  apiClient.get<GetDefiYieldsOverviewResponse>('/v1/earn/defi-yields/overview');

export const getDefiYieldsPendingApi = () => apiClient.get<GetDefiYieldPendingResponse>('/v1/earn/defi-yields/pending');

export const getNarsilOverviewApi = narsilApis.getOverview;
export const getNarsilMintOverviewApi = narsilApis.getMintOverview;
export const postNarsilMintPreviewApi = narsilApis.postMintPreview;
export const postNarsilMintConfirmApi = narsilApis.postMintConfirm;
export const getNarsilRedeemOverviewApi = narsilApis.getRedeemOverview;
export const postNarsilRedeemPreviewApi = narsilApis.postRedeemPreview;
export const postNarsilRedeemConfirmApi = narsilApis.postRedeemConfirm;
export const getNarsilDetailsApi = narsilApis.getDetails;
export const getNarsilPendingApi = narsilApis.getPending;
